import DateRangeIcon from "@mui/icons-material/DateRange";
import classNames from "classnames";
import styles from "./style.module.scss";

interface RangeCaptionProps {
  /** e.g. "11 Aug – 10 Sep (30 days)". */
  range: string;
  /** e.g. "12 Jul – 10 Aug". Omit to drop the comparison clause. */
  comparedWith?: string;
  className?: string;
}

/** One-line caption stating the active range and what it is compared against. */
function RangeCaption({ range, comparedWith, className }: RangeCaptionProps) {
  return (
    <div className={classNames(styles.caption, className)}>
      <DateRangeIcon className={styles.icon} />
      <span>{range}</span>
      {comparedWith && (
        <>
          <span className={styles.dot}>·</span>
          <span>compared with {comparedWith}</span>
        </>
      )}
    </div>
  );
}

export default RangeCaption;
